import * as React from 'react'
import styled from 'styled-components'
import Svg from './Svg'

function BaseComponent(props: any) {
  return (
    <Svg
      width={15}
      height={15}
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.5 0a.5.5 0 000 1H6v11a1 1 0 001 1h1a1 1 0 001-1V1h4.5a.5.5 0 000-1h-12z"
        fill="currentColor"
      />
    </Svg>
  )
}

const SvgAlignTop = styled(BaseComponent)`
  outline: none;
`
export default SvgAlignTop
